import store from '@/store';
import { leadSquardedRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, source, productType, appianIncomeInfo } = store.state;
    const appointmentDate = getValueByFieldName(values, FIELD_NAMES.appointmentDate);
    const appointmentTime = getValueByFieldName(values, FIELD_NAMES.appointmentTime);
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var salesProduct;
    if (product === 'Top Up') {
        salesProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        salesProduct = 'Auto Loan'
    } else {

        salesProduct = product
    }
    let appianDecision;
    if (appianIncomeInfo) {
        if (appianIncomeInfo === 'Conditionally Approved') {
            appianDecision = 'Pre-approved'
        } else {
            appianDecision = appianIncomeInfo;
        }
    }
    if (product === 'Top Up' || product === 'New Car' || product === 'Used Car') {
        return {
            "app-id": appId,
            "source": typeof source !== 'undefined' ? source : "",
            "appointment": typeof appointmentDate !== 'undefined' && typeof appointmentTime !== 'undefined' ? appointmentDate + ' ' + appointmentTime : "",
            "product": salesProduct,
            "appian-decision": typeof appianDecision !== 'undefined' ? appianDecision : ""
        };
    }
    return {
        "app-id": appId,
        "source": typeof source !== 'undefined' ? source : "",
        "appointment": typeof appointmentDate !== 'undefined' && typeof appointmentTime !== 'undefined' ? appointmentDate + ' ' + appointmentTime : "",
        "product": productType,
        "appian-decision": typeof appianDecision !== 'undefined' ? appianDecision : ""
    };
};

export default {
    async leadSquarded(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: leadSquardedRepository.leadSquarded,
            payload: getPayload(),
        });

    }
};